import * as Sentry from '@sentry/browser'
import { appContext } from '../../common/src/context'
import { init } from './view/App'

if (appContext().isProduction) {
  Sentry.init({
    dsn: 'https://8fa45e11389842a38b866ecc05c4c7ca@sentry.io/1881738',
    release: appContext().commitHash,
    environment: 'production',
  })
}
init()
